import { Box } from "@chakra-ui/react";
import { PresenceType } from "@keita/lanepatrol-sdk";
import { MapColoringLegendItem } from "./MapColoringLegendItem";
import {
  mapGradientEnd,
  mapGradientStart,
} from "../../../../map/utils/map-utils";
import { CraAttributeUtils } from "../../../../coding/utils/attribute-utils";

export const MapColoringTreatment: React.FC = () => {
  return (
    <Box>
      <MapColoringLegendItem color={mapGradientStart}>
        {CraAttributeUtils.getOptionLabel(PresenceType.Present)}
      </MapColoringLegendItem>
      <MapColoringLegendItem color={mapGradientEnd}>
        {CraAttributeUtils.getOptionLabel(PresenceType.NotPresent)}
      </MapColoringLegendItem>
    </Box>
  );
};
